import React, { Component } from 'react';
import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import BigWaveYellow from '../../images/BlogPost/element_big-wave-yellow.svg';
import LazyImage from '@/components/LazyLoadImage';

const SubTitle = styled.p`
  color: ${({ color, theme }) => color || theme.colors.gray};
  font-family: 'Lato', sans-serif;
  font-size: ${({ fontSize = '16px' }) => fontSize};
  font-weight: ${({ category }) => (category ? '500' : '400')};
  line-height: 24px;
  letter-spacing: 0.51px;
  padding: ${({ padding = '0' }) => padding};
  margin: ${({ margin = '0' }) => margin};
  border-left: ${({ category, theme }) => category && `3px solid ${theme.colors.yellow}`};
  padding-left: ${({ category }) => category && '8px'};
`;

const Title = styled.h1`
  font-size: 44px;
  line-height: 56px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.gray};
  margin-bottom: 0.5rem;

  span {
    color: ${({ theme }) => theme.colors.green};
  }

  @media (max-width: 768px) {
    font-size: 36px;
    line-height: 44px;
  }
`;

const Section = styled.section`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 56px;

  .bigWave {
    display: block;
    position: absolute;
    bottom: 0;
  }

  @media (max-width: 1280px) {
    .bigWave {
      display: none;
    }
  }

  @media (max-width: 768px) {
    position: initial;
    margin-bottom: 0;
  }
`;

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 2rem 0 3rem;

  @media (max-width: 1280px) {
    width: 72%;
    padding: 4rem 0;
  }

  @media (max-width: 768px) {
    width: 90%;
    padding: 0;
    flex-direction: column;
  }
`;

const Box = styled.div`
  width: 40%;
  margin-left: auto;

  @media (max-width: 1280px) {
    width: 100%;
  }

  @media (max-width: 768px) {
    padding-top: 40px;
  }
`;

const BoxImage = styled.div`
  width: 50%;

  img {
    display: block;
    max-width: 100%;
    margin-left: auto;
    border-radius: 0px 0px 0px 48px;
    background: #b56363;
    box-shadow: 24px 36px 56px rgba(77, 80, 98, 0.15);
  }

  @media (max-width: 1280px) {
    width: 100%;
    position: initial;
    margin: 24px auto;
  }
`;

class MainSection extends Component {
  render() {
    const { category, title, title_post, featuredImage } = this.props;
    return (
      <Section>
        <Container>
          <Box>
            <Title margin="2rem 0 0 0">{title_post}</Title>
            <SubTitle category margin="1rem 0">
              {category}
            </SubTitle>
          </Box>

          <BoxImage>
            <GatsbyImage image={featuredImage} alt={title} />
          </BoxImage>
        </Container>

        <LazyImage className="bigWave" src={BigWaveYellow} alt="" />
      </Section>
    );
  }
}

export default MainSection;
